export const routes = {
  error404: '/404',
  error401: '/401',
  home: '/',
  flights: {
    index: '/flights',
    booking: '/booking/:id',
    payment: '/booking/:id/payment',
    voucher: '/booking/:id/voucher',
  },
  cars: '/cars',
  explorer: '/explorer',
  // Verticales de Rutero: cada uno con su ruta propia en la nav principal.
  transfers: '/transfers',
  experiences: '/experiences',
  esims: '/esims',
  rail: '/trenes',
  buses: '/buses',
  passes: '/pases',
  circuits: '/circuitos',
  ferry: '/ferries',
  hotels: {
    home: '/hotels',
    availability: '/hotels/availability',
    fares: '/hotels/fares',
  },
  hotelPropertyFares: '/hotel-fares/property/:hotelId',
  flightsAvailability: '/flights/shopping',
  dashboard: {
    index: '/dashboard',
    whatsapp: '/dashboard/whatsapp/active-conversations',
    bookings: '/dashboard/bookings',
    bookingView: '/dashboard/bookings/:id',
    travelBookings: '/dashboard/travel-bookings',
    inbox: '/dashboard/inbox',
    inboxCase: '/dashboard/inbox/:caseId',
    cases: '/dashboard/cases',
    caseView: '/dashboard/cases/:id',
    clients: '/dashboard/clients',
    clientView: '/dashboard/clients/:id',
    users: '/dashboard/users',
    userView: '/dashboard/users/:id',
    agencies: '/dashboard/agencies',
    calls: '/dashboard/calls',
    agencyView: {
      root: '/dashboard/agencies/:id',
      settings: 'settings',
      workflows: 'workflows',
      iaCaseEventHandlers: 'case-handlers',
      caseTriggers: 'case-triggers',
      workflow: 'workflows/:workflowId',
      teams: 'teams',
      team: 'teams/:teamId',
      organizations: 'organizations',
      organization: 'organization/:organizationId',
      communications: 'communications',
      callsMenu: 'calls-menu',
      markupRulesList: 'markup-rules',
      markupRulesView: 'markup-rules/:ruleId',
      airRoutingRules: 'air/routing-rules',
      airRoutingRulesView: 'air/routing-rules/:ruleId',
      supportForm: 'support-forms',
      supportFormEdit: 'support-forms/:supportFormId',
      customFields: 'custom-fields',
      customFieldsView: 'custom-fields/:fieldBlockId',
      flightIntegrations: 'flight-integrations/',
      invalidationRules: 'invalidation-rules',
      invalidationRule: 'invalidation-rules/:invalidationRuleId',
      iaConfig: 'ia-config',
      whatsappSettings: 'whatsapp-settings',
      uploads: 'uploads',
      agencyFlightIntegrations: 'agency-flight-integrations',
      webhooks: 'webhooks',
      metaCapi: 'meta-capi',
      copilot: 'copilot',
      agencyKnowledge: 'agency-knowledge',
      rutero: 'rutero',
      hotels: 'hotel-connections',
      vouchers: 'vouchers',
      bookingSettings: 'booking-settings',
    },
    saleOrder: {
      root: '/dashboard/sale-order',
      detail: '/dashboard/sale-order/:id',
      passengers: 'passengers',
      item: 'item/:itemId',
    },
    content: {
      hotel: {
        list: '/dashboard/content/hotel',
        item: '/dashboard/content/hotel/:hotelId',
      },
    },
    rules: {
      route: {
        hotel: {
          list: '/dashboard/rules/routing/hotel',
        },
      },
    },
    flightIntegrations: {
      list: '/dashboard/flights-integrations',
      item: '/dashboard/flights-integrations/:hotelId',
    },
    hotelIntegrations: {
      list: '/dashboard/hotel-integrations',
      item: '/dashboard/hotel-integrations/:hotelId',
    },
    hotelContentManagement: {
      root: '/dashboard/hotel-content-management',
      suppliers: 'suppliers',
      defaultSuppliers: 'default-suppliers',
      boards: 'boards',
      categories: 'categories',
      destinations: 'destinations',
      vendorHotels: 'vendor-hotels',
    },
    hotelContentView: {
      root: '/dashboard/hotel-content-view/:hotelId',
      checkin: 'checkin-checkout',
      location: 'location',
      images: 'images',
      amenities: 'amenities',
      content: 'content',
    },
  },
  salesorder: {
    cart: '/cart',
  },
  external: {
    caseSupportForms: '/support/:id',
  },
};
